import type { ChangelogEntry } from "../types";

/** GEEK på kundekortet vises i hele kroner, ikke prosent eller MNOK. */
export const KUNDEKORT_GEEK_KRONER_2026_10: ChangelogEntry = {
  id: "2026-10-25-kundekort-geek-kroner",
  date: "2026-10-25",
  title: "GEEK i hele kroner på kundekortet",
  summary:
    "Nøkkeltallene og «Det vi har laget» viser GEEK i hele kroner. Prosent av kontrakten og avrundede MNOK-tall er borte.",
  sections: [
    {
      heading: "Kunder",
      minRole: "user",
      items: [
        {
          title: "GEEK i kroner",
          kind: "forbedret",
          featureFlag: "feature_crm_kundekort",
          body: "«GEEK levert» og «GEEK i arbeid» står med fullt kronebeløp, og kontraktssummen under «GEEK levert» likeså. Kolonnen «GEEK reell» i «Det vi har laget» viser bruttofortjenesten i kroner per prosjekt.",
        },
        {
          title: "Budsjettavvik i timer, som i prosjektlista",
          kind: "rettet",
          featureFlag: "feature_crm_kundekort",
          body: "Kolonnen het «Feilbudsj.» og viste avviket i bruttofortjeneste, så et prosjekt som brukte 64 % flere timer enn solgt kunne stå med −19 %. Nå heter den «Budsjettavvik» og viser brukte mot solgte timer, samme tall som lista over avsluttede prosjekter.",
        },
      ],
    },
  ],
};
